import React, { useRef, useEffect, useState } from 'react';

const OurSpirit = () => {
    const componentRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, []);

    return (
        <div ref={componentRef} className={`our-spirit-container ${isVisible ? 'visible' : ''}`}>
            <div className="left-section">
                <h2 className="title">
                    Our Mission
                    <hr className="title-hr" />
                </h2>
                <p className="description">
                To create, preserve and promote the Value Awareness among youth through a systematic education and training program at various levels in the society which will eventually result into holistic growth heralding a constructive transformation of the hearts in order to ensure sustainable peace and happiness all over the world.
                </p>
            </div>
            <div className="center-decoration">
                <div className="star"></div>
                <div className="line"></div>
                <div className="circle"></div>
            </div>
            <div className="right-section">
                <h2 className="title">
                    Our Vision
                    <hr className="title-hr" />
                </h2>
                <p className="paragraph">
                To make the youth thoughtful towards importance of values in day to day life and subsequently train and inspire them to become perfect leader in the society by inculcating values, so that they can create a better India and become an asset to the nation.
                </p>
            </div>
        </div>
    );
};

export default OurSpirit;